export default __webpack_public_path__ + "static/media/voucherGTS5.85d59d57.jpg";